// src/services/nipc-external/nipcService.js
// *******************************************************************************
// NIPC External Search Service
// *******************************************************************************
// Calls the backend NIPC search proxy (POST /v1/nipc-search/search).
// Direct browser calls to NIF.pt and VIES are blocked by CORS, so the backend
// intermediates and returns a Universal POJO aligned with the entity schema.
// *******************************************************************************

import axiosService from 'services/axiosService';
import { API } from 'constants/Api';

// *******************************************************************************
// METHODS
// *******************************************************************************

// Search NIPC via backend proxy (NIF.pt -> VIES fallback, with 24h cache).
// Returns: { success, cached, data (Universal POJO), _id }
const searchNipc = async nipc => {
  try {
    const response = await axiosService.post({
      url: API.NIPC_SEARCH.SEARCH,
      data: { nipc },
      returnAsObject: true,
    });

    const actualResponse = Array.isArray(response) ? response[0] : response;
    return actualResponse || { success: false, data: null };
  } catch (error) {
    return { success: false, data: null };
  }
};

// *******************************************************************************
// EXPORT
// *******************************************************************************

export { searchNipc };

export default { searchNipc };
